import Utils from './utils/utils'

/**
 * 获取登录的用户信息
 * @param data
 * @param success
 * @param error
 */
let getUserInfo = function(data, success, error) {
    data = data ? data : {
        isUpdate: false
    };
    let isUpdate = data.isUpdate ? true : false;
    if (! isUpdate &&  Utils.Cookies.getItem('plt_uid') && Utils.Cookies.getItem('plt_user_nk') && Utils.Cookies.getItem('GWD_USER_TOKEN')) {
        success && 'function' === typeof success && success();
        return;
    }

    const options = {
        isSign: true,
        ac:'User.Detail',
        crossDomain: true,
    };
    Utils.HttpRequest.get('https://i.gwdang.com/User/Detail', null, options, (response) => {
        if (response.code == 1) {
            let d = response.data;
            let expire = 3600 * 24 * 7;
            Utils.Cookies.setItem('plt_uid', d.uid, null, '/', '.gwdang.com');
            Utils.Cookies.setItem('plt_user_nk', d.nickname, null, '/', '.gwdang.com');
            Utils.Cookies.setItem('plt_user_email', '_default', expire, '/', '.gwdang.com');

            success && 'function' === typeof success  && success(d);
        } else {
            error && 'function' === typeof error && error();
        }
    })
};

/**
 * 发送验证邮件
 * 使用场景：邮箱注册/重发、忘记密码、绑定邮箱
 * @param data
 * @param success
 * @param error
 */
let checkEmail = (data, success, error) => {
    data.tag = data.tag || 'bind';

    let u = 'https://i.gwdang.com/UserHelper/SendMail';
    let options = {
        isSign: true,
        ac: 'UserHelper.SendMail',
        crossDomain: true,
    };

    if (data.tag === 'register') {
       options.ac = 'UserHelper.ReSendMail';
       u = 'https://i.gwdang.com/UserHelper/ReSendMail';
    }

    Utils.HttpRequest.post(u, data, options, (response) => {
        if (response.code == 1) {
            success && 'function' === typeof success  && success(response);
        } else {
            error && 'function' === typeof error  && error(response);
        }
    });
}

/**
 * 重置密码
 * @param data
 * @param success
 * @param fail
 */
let resetPasswd = (data, success, fail) => {
    let options = {
        isSign: true,
        ac: 'User.ResetPasswd',
        crossDomain: true,
    };

    Utils.HttpRequest.post('https://i.gwdang.com/User/ResetPasswd', data, options, (response) => {
        if (response.code == 1) {
            success && 'function' === typeof success && success(response);
        } else {
            fail && 'function' === typeof fail && fail(response);
        }
    }, err => {
        console.log(err)
    });
};

/**
 * 账号退出登录
 * @param callback
 */
let doLogout = (callback) => {
    let options = {
        isSign: true,
        ac: 'User.Logout',
        crossDomain: true,
    };
    Utils.HttpRequest.post('https://i.gwdang.com/User/Logout', null, options, (response) => {
        if (response.code == 1) {
            Utils.Cookies.removeItem('plt_uid', '/', '.gwdang.com');
            Utils.Cookies.removeItem('plt_user_nk', '/', '.gwdang.com');
            Utils.Cookies.removeItem('plt_user_email', '/', '.gwdang.com');

            callback && 'function' === typeof callback && callback();
        } else {
            alert('出错了，请联系管理员');
        }
    })
};

export default {
    getUserInfo,
    checkEmail,
    resetPasswd,
    doLogout,
}
